import moment, { Moment } from 'moment';

/**
 * Helpers for sharing a date/time filter range across sibling views (e.g. the
 * worker profile tabs) via an in-memory `DateRangeFilterValues`. Kept pure and
 * free of React so the subtle resolution rules can be unit-tested directly.
 */

/**
 * Resolve the default date for a tab's filter: the persisted ISO date when the
 * container has one, otherwise the tab's own fallback.
 */
export const resolveFilterDate = (
  persisted: string | undefined,
  fallback: Moment,
): Moment => (persisted ? moment(persisted) : fallback);

/**
 * Resolve the time to display/query: the URL value (picked this session) takes
 * precedence, then any value persisted from a sibling tab. Uses `||` — not
 * `??` — because `parseTimeFromUrl` yields `''` (not `undefined`) for an absent
 * URL param, and that empty string must fall through to the persisted value.
 * Returns `undefined` when no time is specified anywhere.
 */
export const resolveFilterTime = (
  urlTime: string | undefined,
  persistedTime: string | undefined,
): string | undefined => urlTime || persistedTime || undefined;
